import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { WorkBatch } from '../work-batch'
import { WorkBatchDetailComponent } from '../work-batch-detail/work-batch-detail.component'

export interface IWorkBatchDialogOptions {
  readonly batch: WorkBatch
}

@Component({
  selector: 'app-work-batch-detail-dialog',
  templateUrl: './work-batch-detail-dialog.component.html',
  styleUrls: ['./work-batch-detail-dialog.component.scss'],
  imports: [WorkBatchDetailComponent],
})
export class WorkBatchDetailDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly batch: WorkBatch
  dialogRef = inject<MatDialogRef<WorkBatchDetailDialogComponent>>(MatDialogRef)
  data = inject<IWorkBatchDialogOptions>(MAT_DIALOG_DATA)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.batch = this.data.batch
  }

  /***************************************************************************
   *                                                                         *
   * Component Events                                                        *
   *                                                                         *
   **************************************************************************/

  public close(): void {
    this.dialogRef.close()
  }
}
